import React from 'react';

import styles from './educationStyles';

const WorkExperience = ({ userProfile }) => {
  return (
    <ul className={styles.educationList}>
      {userProfile.schoolHistories.map((schoolHistory, idx) => {
        const {
          schoolName,
          degree,
          fieldOfStudy,
          currentStudent,
          startYear,
          gradYear
        } = schoolHistory;
        return (
          <li key={idx}>
            <h4>{schoolName}</h4>
            <h5 className={styles.educationDegreeInfo}>
              {degree}
              {degree && fieldOfStudy && ', '}
              {fieldOfStudy}
            </h5>
            {!!startYear && (!!currentStudent || !!gradYear) && (
              <span>
                {startYear} – {currentStudent ? 'Present' : gradYear}
              </span>
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default WorkExperience;
